module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Inst Cuerdas Frotadas RO.9e9a39f8.png";